import DropdownMenu, { type DropdownMenuProps } from '@/legacy-src/components/button/DropdownMenu'
import { getTranslate } from '@/legacy-src/utilities/i18n'

import { FreeSlotTypeFilter } from '@/src/domains/client-booking/constants'

export interface ClientBookingFreeSlotTypeFilterUIProps {
  value: FreeSlotTypeFilter | null
  className?: string
  onChange: (value: FreeSlotTypeFilter | null) => void
}

export const ClientBookingFreeSlotTypeFilterUI = ({
  value,
  className,
  onChange,
}: ClientBookingFreeSlotTypeFilterUIProps) => {
  const { t } = getTranslate()

  const items: NonNullable<DropdownMenuProps['listItems']> = [
    {
      text: t('component.clientBooking.appointmentTypeFilter.all'),
      icon: 'hybrid',
      onClick: () => {
        onChange(null)
      },
    },
    {
      value: FreeSlotTypeFilter.OFFLINE,
      text: t('component.clientBooking.appointmentTypeFilter.offline'),
      icon: 'location',
      onClick: () => {
        onChange(FreeSlotTypeFilter.OFFLINE)
      },
    },
    {
      value: FreeSlotTypeFilter.ONLINE,
      text: t('component.clientBooking.appointmentTypeFilter.online'),
      icon: 'video',
      onClick: () => {
        onChange(FreeSlotTypeFilter.ONLINE)
      },
    },
  ]

  const mainItem = items.find((item) => (item.value ?? null) === value) ?? items[0]
  return (
    <DropdownMenu className={className} dataTestId="appointment-type-filter" mainItem={mainItem} listItems={items} />
  )
}
